"use strict";
/** @jsx jsx */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Paper = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (core_1.jsx("div", Object.assign({ className: carabiners_1.joinStr(styles_scss_1.default.paper, className) }, rest), children));
};
exports.default = Paper;
